<ion-app>
	<!-- <h1 *ngIf="authFacade.loading$ | async; else notLoading">Loading...</h1>
	<ng-template #notLoading> -->

	<ion-router-outlet></ion-router-outlet>
	<!-- </ng-template> -->

</ion-app>
